<template>
  <div class="d-signup-modal-signup">
    <div class="discovery-logo-black" />

    <h2>You'll need an account for that!</h2>
    <p class="large space-bottom-2em">
      Get early access to fresh indie books and help decide on the
      bestselling stories of tomorrow.
    </p>

    <!-- Desktop -->
    <div class="hidden-until-md">
      <div class="grid-flex grid-no-response grid-middle space-top-2em">
        <div class="grid-item-shrink">
          <a
            title="Facebook"
            @click.prevent="trackEventAndRedirect('social-sign-in-request', signUpUrls.facebook)"
          >
            <img
              :src="images.facebookSignIn"
              alt="Facebook"
            >
          </a>
        </div>
        <p class="grid-item-shrink large space-left-1em space-right-1em">
          or
        </p>
        <div class="grid-item">
          <a
            title="Google"
            @click.prevent="trackEventAndRedirect('social-sign-in-request', signUpUrls.google)"
          >
            <img
              :src="images.googleSignIn"
              alt="Google"
            >
          </a>
        </div>
      </div>
      <p class="text-center large space-top-1em space-bottom-none">
        Sign up with an
        <a
          title="Email address"
          @click.prevent="trackEventAndRedirect('sign-up-request', signUpUrls.regular)"
        >
          email address
        </a>
        or
        <a
          title="Log in"
          @click.prevent="trackEventAndRedirect('sign-in-request', signInUrl)"
        >log in</a>
      </p>
    </div>

    <!-- Mobile -->
    <div class="visible-until-sm">
      <a
        class="button button-lg button-yellow button-full-sm"
        @click.prevent="trackEventAndRedirect('sign-up-request', signUpUrls.regular)"
      >
        <div class="grid-flex grid-no-response">
          <div class="grid-item text-center">
            <span class="space-right-1em">Create your account</span>
          </div>
          <div class="grid-item-shrink">
            <DuiIconArrowRight
              class="icon-lg icon-white"
              style="margin: -10px 0 -6px;"
            />
          </div>
        </div>
      </a>

      <p class="space-top-2em">
        Or sign up with your social account
      </p>

      <div class="button-pair space-top-1em">
        <a
          class="button button-facebook button-full"
          title="Facebook"
          @click.prevent="trackEventAndRedirect('social-sign-in-request', signUpUrls.facebook)"
        >
          <img :src="images.facebook">
          <span>Facebook</span>
        </a>

        <a
          class="button button-google button-full button-white-bordered"
          title="Google"
          @click.prevent="trackEventAndRedirect('social-sign-in-request', signUpUrls.google)"
        >
          <img :src="images.google">
          <span>Google</span>
        </a>
      </div>

      <p class="text-center space-top-2em space-bottom-none">
        Do you have an account?
        <a
          title="Log in here"
          @click.prevent="trackEventAndRedirect('sign-in-request', signInUrl)"
        >Log in here</a>
      </p>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import URLS from '@d-shared/urls/urls';
import Window from '@d-shared/utils/window';

export default {
  data: () => ({
    images: {
      facebook: require('@d-assets/facebook-white.svg'),
      facebookSignIn: require('@d-assets/facebook-sign-in.svg'),
      google: require('@d-assets/google.svg'),
      googleSignIn: require('@d-assets/google-sign-in.svg'),
    },
    signInUrl: URLS.app.signIn,
    signUpUrls: {
      facebook: URLS.app.signUp.facebook,
      google: URLS.app.signUp.google,
      regular: URLS.app.signUp.regular,
    },
  }),
  methods: {
    trackEventAndRedirect(eventName, link) {
      Vue.prototype.eventsTracking.trackAndRedirect(eventName, {}, link);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.d-signup-modal-signup {
  .button-facebook,
  .button-google {
    img {
      height: $_3em;
      width: $_3em;
    }
  }
}
</style>
